module.exports = __webpack_public_path__ + "img/expo2024_square.fa9100b.png";